import Vue from 'vue'

export default {
    setResults(state, payload) {
      Vue.set(state, 'results', payload)
    },
    setIsSearched(state, payload) {
      Vue.set(state, 'isSearched', payload)
    },
    setSearching(state, payload) {
      Vue.set(state, 'searching', payload)
    },
    setOverOllSearching(state, payload) {
        Vue.set(state, 'overAllSearching', payload)
    },
    setUpperShow(state, payload) {
        Vue.set(state, 'upperShow', payload)
    }
}
